import {
  EventType,
  InteractionRequiredAuthError,
  PublicClientApplication,
} from '@azure/msal-browser';
import { loginRequest, msalConfig } from './authConfig';

export const msalInstance = new PublicClientApplication(msalConfig);

export const Authenticator = (): any => {
  const accounts = msalInstance.getAllAccounts();

  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  msalInstance.addEventCallback((event: any) => {
    if (
      event.eventType === EventType.LOGIN_SUCCESS &&
      event?.payload?.account
    ) {
      const { account } = event.payload;
      msalInstance.setActiveAccount(account);
    }

    if (event.eventType === EventType.LOGIN_FAILURE) {
      console.log('Authenticator listener ', JSON.stringify(event));
    }

    if (event.eventType === EventType.SSO_SILENT_FAILURE) {
      console.log('Authenticator listener ', JSON.stringify(event));

      msalInstance.loginRedirect();
    }
  });
};

export const getValidToken = async (): Promise<any> => {
  const account = msalInstance.getActiveAccount();
  if (!account) {
    msalInstance.loginRedirect();
    return null;
  }

  const conf = {
    account,
    ...loginRequest,
  };

  try {
    const response = await msalInstance.acquireTokenSilent(conf);
    if (response) {
      return response.accessToken;
    }
  } catch (tokenError) {
    if (tokenError instanceof InteractionRequiredAuthError) {
      try {
        await msalInstance.loginRedirect();
        return null;
      } catch (error) {
        console.log('AuthProvider : loginRedirect error ', error);
        msalInstance.logoutRedirect();
      }
    } else {
      console.log('AuthProvider : tokenError ', tokenError);
      msalInstance.logoutRedirect();
    }
  }
  return null;
};

export const UserLogin = async (): Promise<any> => {
  const account = msalInstance.getActiveAccount();
  if (!account) {
    msalInstance.loginRedirect();
  }
  return null;
};
